// extracted by mini-css-extract-plugin
module.exports = {"module":"village-quarter_module__34BuV","townhouse":"village-quarter_townhouse__1nWcg","title":"village-quarter_title__1IUzW","items":"village-quarter_items__1Yir8"};